module.exports = __webpack_public_path__ + "img/light1.b04e4ca9.png";